import { createPortal } from 'react-dom';
import { usePopperTooltip } from 'react-popper-tooltip';
import 'react-popper-tooltip/dist/styles.css';

import PropTypes from 'prop-types';

import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledContainer = styled(Box)(({ theme }) => ({
  maxWidth: '40rem',
  backgroundColor: 'white',
  borderRadius: '1rem',
  border: '.1rem solid silver',
  boxShadow: '0 .2rem .4rem rgba(0, 0, 0, 0.18)',
  display: 'flex',
  flexDirection: 'column',
  margin: '0.5rem',
  padding: '0.5rem',
  transition: 'opacity 0.3s',
  zIndex: 9999,
  overflowWrap: 'anywhere',
  whiteSpace: 'break-spaces',
  [theme.breakpoints.down('md')]: {
    maxWidth: '30rem',
  },
}));

const Tooltip = ({ children, tooltip, placement, trigger, customStyle }) => {
  const { getTooltipProps, setTooltipRef, setTriggerRef, visible } =
    usePopperTooltip({ placement, trigger });

  if (!tooltip) return children;

  return (
    <>
      <Box
        style={{ display: 'block', ...customStyle }}
        className="crop-long-text"
        ref={setTriggerRef}
      >
        {children}
      </Box>
      {visible &&
        createPortal(
          <StyledContainer ref={setTooltipRef} {...getTooltipProps()}>
            {tooltip}
          </StyledContainer>,
          document.body,
        )}
    </>
  );
};

Tooltip.defaultProps = {
  tooltip: null,
  placement: 'top',
  trigger: 'hover',
  customStyle: {},
};

Tooltip.propTypes = {
  children: PropTypes.node,
  tooltip: PropTypes.node,
  placement: PropTypes.string,
  trigger: PropTypes.string,
  customStyle: PropTypes.instanceOf(Object),
};

export default Tooltip;
